package pl.decks.personal.components.widgets.iconribbon

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.CSSTimeNumericValue
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.AnimationDirection
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.ms


enum class IconRibbonVariant {
    COLLAPSED,
    EXPANDED,
    COLLAPSING;

    fun next() = when (this) {
        COLLAPSED -> EXPANDED
        EXPANDED -> COLLAPSING
        COLLAPSING -> COLLAPSING
    }

    enum class Phase { I, II; }

    private data class Animator(
        val phase1Duration: CSSTimeNumericValue,
        val phase2Duration: CSSTimeNumericValue,
        val phase1Delay: CSSTimeNumericValue,
        val phase2Delay: CSSTimeNumericValue,
        val timingFunction: AnimationTimingFunction,
        val direction: AnimationDirection,
        val fillMode: AnimationFillMode = AnimationFillMode.Both,
    )

    private fun animator(): Animator? {
        val phase1Dur = IconRibbonStylesheet.Vars.phase1Duration.value()
        val phase2Dur = IconRibbonStylesheet.Vars.phase2Duration.value()
        return when (this) {
            EXPANDED -> Animator(
                phase1Duration = phase1Dur,
                phase2Duration = phase2Dur,
                phase1Delay = 0.ms,
                phase2Delay = phase1Dur,
                timingFunction = AnimationTimingFunction.EaseOut,
                direction = AnimationDirection.Normal,
                fillMode = AnimationFillMode.Both,
            )

            COLLAPSING -> Animator(
                phase1Duration = phase1Dur,
                phase2Duration = phase2Dur,
                phase1Delay = phase2Dur,
                phase2Delay = 0.ms,
                timingFunction = AnimationTimingFunction.EaseIn,
                direction = AnimationDirection.Reverse,
                fillMode = AnimationFillMode.Both,
            )

            else -> null
        }
    }

    @Composable
    fun animate(keyframes: Keyframes, phase: Phase): Animation.Listable? = animator()?.let { animator ->
        when (phase) {
            Phase.I -> keyframes.toAnimation(
                duration = animator.phase1Duration,
                timingFunction = animator.timingFunction,
                delay = animator.phase1Delay,
                direction = animator.direction,
                fillMode = animator.fillMode,
            )

            Phase.II -> keyframes.toAnimation(
                duration = animator.phase2Duration,
                timingFunction = animator.timingFunction,
                delay = animator.phase2Delay,
                direction = animator.direction,
                fillMode = animator.fillMode,
            )
        }
    }
}